export var AlignItems = Object.freeze({
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Center: 'center',
  Stretch: 'stretch',
  Baseline: 'baseline'
});
export var JustifyContent = Object.freeze({
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Center: 'center',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
});
export var Direction = Object.freeze({
  Row: 'row',
  Column: 'column'
});
export var FlexWrap = Object.freeze({
  NoWrap: 'nowrap',
  Wrap: 'wrap',
  WrapReverse: 'wrap-reverse',
  Initial: 'initial',
  Inherit: 'inherit'
});